// removed by extract-text-webpack-plugin
module.exports = {"button":"_36DQt","backButton":"_2aU1S","page":"_3NVdb","heading":"_1Lzpe","user":"KJN86","userChecked":"_2Jy_m KJN86","checkbox":"j_3M1","checkboxChecked":"_1cg3K j_3M1","tick":"_3S5wR","userName":"_2zX9w","userEmail":"_10ios","note":"_2Py_u","buttons":"_3VBtT","label":"_21ijD","link":"_3SvFN","editLink":"_3jVfk _3SvFN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/album/common.css
// module id = 170
// module chunks = 0